import { apiGet, apiPost } from './utils';

export interface FileAssociation {
  uuid: string;
  key: string;
  file: string;
  user?: string;
  associated_type: string;
  associated_uuid: string;
  date_created: string;
}

export interface AssociatedFileInfo {
  association_uuid: string;
  file_uuid: string;
  filename: string;
  content_type: string;
  size: number | null;
  date_created: string | null;
}

export const fileAssociationApi = {
  /**
   * Create a file association linking a file to a request, collab, etc.
   */
  async create(
    fileUuid: string,
    associatedType: string,
    associatedUuid: string
  ): Promise<FileAssociation> {
    return apiPost<FileAssociation>('/file-association/create', {
      file: fileUuid,
      associated_type: associatedType,
      associated_uuid: associatedUuid,
    });
  },

  /**
   * Get file associations for multiple associated UUIDs of the same type.
   * Returns a map of associated_uuid -> array of file info.
   */
  async listByAssociations(
    associatedType: string,
    associatedUuids: string[]
  ): Promise<{ items: Record<string, AssociatedFileInfo[]> }> {
    return apiGet<{ items: Record<string, AssociatedFileInfo[]> }>(
      '/file-association/list/by-associations',
      {
        associated_type: associatedType,
        associated_uuids: associatedUuids.join(','),
      }
    );
  },
};
